import { MessageCircle, TrendingUp } from "lucide-react";
import { Reveal } from "./shared";
import { WHATSAPP_URL } from "@/lib/api";

export const GasBillBanner = () => (
  <section className="bg-white pb-24 sm:pb-32" data-testid="gas-bill-banner">
    <div className="mx-auto max-w-6xl px-5 lg:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-3xl bg-[var(--dark-bg)] px-8 py-12 sm:px-14">
          <div className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-[var(--primary)]/15 blur-[100px]" />
          <div className="relative flex flex-col items-center gap-8 text-center lg:flex-row lg:text-left">
            <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-[var(--primary)]/15">
              <TrendingUp size={30} className="text-[var(--primary)]" />
            </span>
            <div className="flex-1">
              <h3 className="font-display text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-testid="gas-bill-title">
                Aumento na <span className="italic text-[var(--primary)]">conta de gás?</span>
              </h3>
              <p className="mt-3 max-w-2xl text-base leading-relaxed text-zinc-400">
                Seu consumo continua igual e a conta de <b className="text-zinc-200">gás encanado</b> não
                para de aumentar? Fale com nossa equipe para realizar uma{" "}
                <b className="text-zinc-200">Visita Técnica e Análise de conta</b>.
              </p>
            </div>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="gas-bill-whatsapp-button"
              className="flex shrink-0 items-center gap-2.5 rounded-full bg-[var(--whatsapp)] px-7 py-4 font-display text-base font-bold uppercase tracking-wider text-black shadow-[0_8px_40px_rgba(37,211,102,0.35)] transition-transform duration-300 hover:scale-105"
            >
              <MessageCircle size={19} strokeWidth={2.5} />
              Falar com Técnico
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
